// All formatting functions go here (e.g. date, time, currency, full name etc.)

export const localizeDate = (dateISO?: string | null, locale?: string) => {
  if (!dateISO) return
  const date = dateISO ? new Date(dateISO) : new Date()
  if (!date || isNaN(date?.getTime())) {
    console.warn('Date is invalid', dateISO)
    return null
  }
  return date.toLocaleDateString(locale)
}
